export class CsValuePanelEventArgs {
	public constructor(
		public action: string,
		public value: any
	) {
	};
}
